import useModalStore from "@/store/modal.store";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

const Modal = () => {
  const {
    isOpen,
    componentName: ComponentToRender,
    componentProps,
    closeModal,
    contentStyle,
  } = useModalStore();

  if (!isOpen || !ComponentToRender) return null;

  return (
    <>
      <Dialog open={isOpen} onOpenChange={closeModal} className="dark:bg-gray-100">
        <DialogContent className={cn("mx-2 dark:bg-gray-100", contentStyle)}>
          <ComponentToRender {...componentProps} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Modal;
